<template id="pinche">

  <el-form :model="ruleForm"  ref="ruleForm" label-width="100px" class="demo-ruleForm">

  <el-form-item label="开通拼车" prop="delivery">
    <el-switch v-model="ruleForm.groupBuyingCarOption"></el-switch>

  </el-form-item>
  <el-form-item label="链接" prop="groupBuyingCarLink" :rules="[{ required: ruleForm.groupBuyingCarOption?true:false, message: '链接不能为空'}]">

  <el-input v-model="ruleForm.groupBuyingCarLink" ></el-input>
  <el-row>
  <el-col :span="24"><span style="font-size:12px;color:#8492A6;">若无拼车链接，请联系你所对应的负责人进行了解开通哦！</span></el-col>
</el-row>

  </el-form-item>
  <el-form-item label="开通挪车" prop="delivery">
    <el-switch v-model="ruleForm.moveCarOption"></el-switch>
  </el-form-item>
  <el-form-item label="链接" prop="moveCarLink" :rules="[{ required: ruleForm.moveCarOption?true:false, message: '链接不能为空'}]">

  <el-input v-model="ruleForm.moveCarLink" ></el-input>
  <el-row>
  <el-col :span="24"><span style="font-size:12px;color:#8492A6;">若无挪车链接，请联系你所对应的负责人进行了解开通哦！</span></el-col>
</el-row>

  </el-form-item>
  <el-form-item label="开通二手车" prop="delivery">
    <el-switch v-model="ruleForm.secondHandCarOption"></el-switch>
  </el-form-item>
  <el-form-item label="链接" prop="secondHandCarLink" :rules="[{ required: ruleForm.secondHandCarOption?true:false, message: '链接不能为空'}]">

  <el-input v-model="ruleForm.secondHandCarLink" ></el-input>
  <el-row>
  <el-col :span="24"><span style="font-size:12px;color:#8492A6;">若无二手车链接，请联系你所对应的负责人进行了解开通哦！</span></el-col>
</el-row>

  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="validateFrom('ruleForm',submitForm)">保存</el-button>

  </el-form-item>
</el-form>

</template>

<script>
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'

import channelModel from '@/framework/models/channelModel'
export default {
  name: 'pinche-config',
  extends: BasicPager,
  data () {
    return {
      ruleForm: {
        groupBuyingCarLink: '',
        groupBuyingCarOption: true,
        moveCarOption: true,
        moveCarLink: '',
        secondHandCarOption: false,
        secondHandCarLink: ''
      }

    }
  },
  created: function () {
    this.init()
  },
  methods: {
    submitForm () {
      let that = this
      let loginInfo = this.loginInfo

      let form = that.ruleForm
      let param = {
        groupBuyingCarLink: form.groupBuyingCarLink,
        groupBuyingCarOption: form.groupBuyingCarOption,
        moveCarLink: form.moveCarLink,
        moveCarOption: form.moveCarOption,
        secondHandCarOption: form.secondHandCarOption,
        secondHandCarLink: form.secondHandCarLink,
        channelId: loginInfo.id
      }

      let listener = {
        success: function (dataInfo) {
          that.$message({
            type: 'success',
            message: '操作成功！'
          })
        }
      }

      channelModel.setPincheConfig(that, param, listener)
    },
    init () {
      let that = this
      let loginInfo = this.loginInfo

      let param = {
        channelId: loginInfo.id
      }

      let listener = {
        success: function (dataInfo) {
          that.ruleForm.groupBuyingCarLink = dataInfo.datas.groupBuyingCarLink
          that.ruleForm.groupBuyingCarOption = dataInfo.datas.groupBuyingCarOption
          that.ruleForm.moveCarLink = dataInfo.datas.moveCarLink
          that.ruleForm.moveCarOption = dataInfo.datas.moveCarOption
          that.ruleForm.secondHandCarOption = dataInfo.datas.secondHandCarOption
          that.ruleForm.secondHandCarLink = dataInfo.datas.secondHandCarLink
        }
      }

      channelModel.selectPincheConfig(that, param, listener)
    }
  }
}
</script>
